export function getView(value) {
  return value.patient_option === 'new' || Boolean(value.patient_id)
}
